<template>
  <div class="echart" :style="{ width, height }"></div>
</template>

<script>
import echarts from 'echarts';
export default {
  name: 'Vchart',
  props: {
    option: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      chart: null,
      width: '100%',
      height: '100%'
    };
  },
  watch: {
    option: {
      handler(newVal, oldVal) {
        this.setOption(newVal);
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart(this.$el);
      // 指定图表的配置项和数据
      this.setOption(this.option);
    });
    ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange'].forEach((item, index) => {
      document.addEventListener(item, this.chartResize);
    });
  },
  beforeDestroy() {
    this.dispose();
    ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange'].forEach((item, index) => {
      document.removeEventListener(item, this.chartResize);
    });
  },
  methods: {
    chartResize() {
      this.chart.resize();
    },
    // 初始化图标
    initChart(el) {
      this.chart = echarts.init(el, null, {
        renderer: 'svg' // 大量图标时候建议使用svg
      });
    },
    // 设置配置项
    setOption(option) {
      if (!this.chart) {
        return;
      }
      this.chart.setOption(option, true);
    },
    // 销毁
    dispose() {
      if (!this.chart) {
        return;
      }
      this.chart = null;
    }
  }
};
</script>
<style lang="scss" scoped></style>
